"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OtherInput = exports.OtherCheckBox = exports.CheckboxGroupDivider = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.function.name.js");
var _reactCheckboxGroup = require("react-checkbox-group");
var _radioCheckboxLabelHolder = _interopRequireWildcard(require("./labels/radioCheckboxLabelHolder"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _formElements = require("@evidation/form-elements");
var _commonComponents = require("../commonComponents");
var _lodash = _interopRequireDefault(require("lodash"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
var _ui = require("@evidation/ui");
var _utils2 = require("../utils");
var _excluded = ["disabled", "displayLabel", "split", "required", "displaySingleOptionLabel", "other"],
  _excluded2 = ["items", "input", "meta", "config", "labelStyle", "ComponentWrapper", "otherLabel", "t", "labelTooltip", "hint_text"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OtherInput = exports.OtherInput = (0, _styledComponents["default"])(_formElements.TextInput).withConfig({
  displayName: "checkboxGroup__OtherInput"
})(["max-width:300px;"]);
var OtherCheckBox = exports.OtherCheckBox = (0, _styledComponents["default"])(_commonComponents.RadioCheckbox).withConfig({
  displayName: "checkboxGroup__OtherCheckBox"
})(["display:flex !important;flex-direction:column !important;align-items:baseline !important;"]);
var CheckboxGroupDivider = exports.CheckboxGroupDivider = _styledComponents["default"].div.withConfig({
  displayName: "checkboxGroup__CheckboxGroupDivider"
})(["border-bottom:1px solid transparent;"]);
var getSelectedValues = function getSelectedValues() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var initialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var val = value || initialValues;
  if (!val) {
    return [];
  }
  if (_lodash["default"].isArray(val)) {
    return val;
  } else {
    return [val];
  }
};
var buildUniqueId = function buildUniqueId(name, label, value) {
  return "t-".concat(name ? name.replace(/\s/g, '') : _lodash["default"].snakeCase(label), "_").concat(_lodash["default"].snakeCase("".concat(value)));
};
var defaultOtherState = {
  otherChecked: false,
  otherValue: ''
};
var CheckboxGroup = /*#__PURE__*/function (_PureComponent) {
  function CheckboxGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CheckboxGroup);
    _this = _callSuper(this, CheckboxGroup, [props]);
    (0, _defineProperty2["default"])(_this, "getOptionsAndValues", function () {
      var _this$props2;
      var _this$props = _this.props,
        value = _this$props.input.value,
        _this$props$config = _this$props.config,
        opts = _this$props$config.options,
        mutually_exclusive_answers = _this$props$config.mutually_exclusive_answers,
        initialValue = _this$props$config.value;
      var exclusives = mutually_exclusive_answers === null || mutually_exclusive_answers === void 0 ? void 0 : mutually_exclusive_answers.map(function (opt) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          exclusive: true
        });
      });
      var checkboxOptions = (0, _toConsumableArray2["default"])(opts);
      var options = (0, _utils.checkboxOptionNormalization)(checkboxOptions);
      var exclusiveOptions = (exclusives === null || exclusives === void 0 ? void 0 : exclusives.length) > 0 ? (0, _utils.checkboxOptionNormalization)(exclusives) : [];
      var selectedValues = getSelectedValues(value || initialValue, (_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.initialValues);
      return {
        options: options,
        selectedValues: selectedValues,
        exclusiveOptions: exclusiveOptions
      };
    });
    (0, _defineProperty2["default"])(_this, "handleOnChange", function (newSelectedValues, evt) {
      var _this$props$config2;
      if (!((_this$props$config2 = _this.props.config) !== null && _this$props$config2 !== void 0 && _this$props$config2.mutually_exclusive_answers)) {
        // this block is mainly for legacy tests but if theres no mutually_exclusive_answers
        // we really dont need to change the original logic here.
        _this.setState({
          selectedValues: newSelectedValues
        }, _this.onChange);
        return;
      }
      var selectedOption = [].concat((0, _toConsumableArray2["default"])(_this.state.options), (0, _toConsumableArray2["default"])(_this.state.exclusiveOptions)).find(function (opt) {
        return (opt === null || opt === void 0 ? void 0 : opt.answer) === Number(evt.target.value);
      });
      if (selectedOption) {
        if (selectedOption !== null && selectedOption !== void 0 && selectedOption.exclusive) {
          _this.setState({
            selectedValues: evt.target.checked ? [selectedOption.answer] : []
          }, _this.onChange);
        } else {
          var selectedOptionsWithoutExclusives = newSelectedValues === null || newSelectedValues === void 0 ? void 0 : newSelectedValues.map(function (v) {
            return _this.state.options.find(function (o) {
              return (o === null || o === void 0 ? void 0 : o.answer) === v;
            });
          }).filter(function (opt) {
            return !(opt !== null && opt !== void 0 && opt.exclusive);
          }).map(function (opt) {
            return opt === null || opt === void 0 ? void 0 : opt.answer;
          });
          _this.setState({
            selectedValues: selectedOptionsWithoutExclusives
          }, _this.onChange);
        }
      }
    });
    (0, _defineProperty2["default"])(_this, "onChange", function () {
      var _this$state = _this.state,
        selectedValues = _this$state.selectedValues,
        otherValue = _this$state.otherValue;

      // this component sends a single value as an array
      // so we just check for 1 result, in the original options,
      // and use the index 0
      var newVals = _this.state.options.length === 1 ? selectedValues[0] : _lodash["default"].without([].concat((0, _toConsumableArray2["default"])(selectedValues), [otherValue]), null, undefined, '');
      _this.props.input.onChange(newVals);
    });
    (0, _defineProperty2["default"])(_this, "focusOther", function () {
      _this.otherInput.current.focus();
    });
    (0, _defineProperty2["default"])(_this, "handleOtherChecked", function (e) {
      if (e.target.checked) {
        _this.setState({
          otherChecked: true
        }, _this.focusOther);
      } else {
        var selectedValues = _lodash["default"].without(_this.state.selectedValues, _this.state.otherValue);
        _this.setState(_objectSpread({
          selectedValues: selectedValues
        }, defaultOtherState));
      }
    });
    _this.otherInput = /*#__PURE__*/_react["default"].createRef();
    var _this$getOptionsAndVa = _this.getOptionsAndValues(),
      _options = _this$getOptionsAndVa.options,
      _selectedValues = _this$getOptionsAndVa.selectedValues,
      _exclusiveOptions = _this$getOptionsAndVa.exclusiveOptions;
    _this.state = _objectSpread({
      selectedValues: _selectedValues,
      options: _options,
      exclusiveOptions: _exclusiveOptions
    }, defaultOtherState);
    return _this;
  }
  (0, _inherits2["default"])(CheckboxGroup, _PureComponent);
  return (0, _createClass2["default"])(CheckboxGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevValues = getSelectedValues(prevProps.input.value);
      var newValues = getSelectedValues(this.props.input.value);
      if (prevValues.length > 0 && newValues.length === 0) {
        this.setState({
          selectedValues: newValues
        });
      }
      if (_lodash["default"].difference(newValues, prevValues).length > 0) {
        this.setState({
          selectedValues: newValues
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectedValues = this.state.selectedValues;
      var _this$props3 = this.props,
        items = _this$props3.items,
        input = _this$props3.input,
        meta = _this$props3.meta,
        _this$props3$config = _this$props3.config,
        _this$props3$config$d = _this$props3$config.disabled,
        disabled = _this$props3$config$d === void 0 ? false : _this$props3$config$d,
        _this$props3$config$d2 = _this$props3$config.displayLabel,
        displayLabel = _this$props3$config$d2 === void 0 ? true : _this$props3$config$d2,
        _this$props3$config$s = _this$props3$config.split,
        split = _this$props3$config$s === void 0 ? false : _this$props3$config$s,
        _this$props3$config$r = _this$props3$config.required,
        required = _this$props3$config$r === void 0 ? false : _this$props3$config$r,
        _this$props3$config$d3 = _this$props3$config.displaySingleOptionLabel,
        displaySingleOptionLabel = _this$props3$config$d3 === void 0 ? false : _this$props3$config$d3,
        other = _this$props3$config.other,
        config = (0, _objectWithoutProperties2["default"])(_this$props3$config, _excluded),
        labelStyle = _this$props3.labelStyle,
        ComponentWrapper = _this$props3.ComponentWrapper,
        otherLabel = _this$props3.otherLabel,
        t = _this$props3.t,
        labelTooltip = _this$props3.labelTooltip,
        hint_text = _this$props3.hint_text,
        rest = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded2);
      var _this$getOptionsAndVa2 = this.getOptionsAndValues(),
        options = _this$getOptionsAndVa2.options,
        exclusiveOptions = _this$getOptionsAndVa2.exclusiveOptions;
      var onlyOneOption = options.length === 1;
      // By default, if there is only one option available, we only show the
      // checkbox with the label of the input, skipping the option label entirely.
      // You can disable this behavior by passing `true` to
      // `config.displaySingleOptionLabel`.
      var onlyDisplayPrimaryLabel = !displaySingleOptionLabel && onlyOneOption;
      var showError = (meta === null || meta === void 0 ? void 0 : meta.touched) && !!meta.error;
      var hasExclusiveAnswers = !!config.mutually_exclusive_answers;
      var makeInputs = function makeInputs(opts) {
        var exclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        return _lodash["default"].map(opts, function (item, i) {
          var _alwaysGetKeyValue = (0, _utils.alwaysGetKeyValue)(item),
            label = _alwaysGetKeyValue.label,
            value = _alwaysGetKeyValue.value;
          var unique_id = buildUniqueId(exclusive ? "".concat(config.name, "_exclusive") : config.name, label, value);
          var output = /*#__PURE__*/_react["default"].createElement(_commonComponents.RadioCheckbox, {
            split: split,
            options: options,
            key: "".concat(unique_id, "_").concat(i)
          }, displayLabel || onlyOneOption ? /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], {
            label: onlyDisplayPrimaryLabel ? rest.label : label,
            labelStyle: labelStyle,
            labelFor: unique_id
          }, /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.Checkbox, {
            id: unique_id,
            value: value,
            disabled: disabled,
            className: "checkbox",
            "aria-describedby": "".concat(buildUniqueId(config.name + '_error-message', null, ''), " ").concat(input.name, "_hint"),
            tabindex: "0"
          })) : /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.Checkbox, {
            id: unique_id,
            value: value,
            disabled: disabled,
            "aria-describedby": "".concat(buildUniqueId(config.name + '_error-message', null, ''), " ").concat(input.name, "_hint"),
            tabindex: "0"
          }));
          if (ComponentWrapper) {
            return /*#__PURE__*/_react["default"].createElement(ComponentWrapper, {
              "interface": "checkbox",
              nested: true,
              name: "".concat(config.name, ".").concat(i),
              key: "".concat(unique_id, "_").concat(i),
              index: i
            }, output);
          }
          return output;
        });
      };
      // checkboxDepth is checking for depth of elements
      // this is a requirement of the checkbox-group component
      // it helps with rendering speed.
      return /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: ComponentWrapper ? 6 : 5,
        className: "checkboxgroup ".concat((0, _utils.constructFieldClassname)(meta)),
        name: input.name,
        value: selectedValues,
        onChange: this.handleOnChange
      }, /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleFieldset, {
        isExclusiveAnswer: hasExclusiveAnswers,
        error: showError
      }, displayLabel && !(onlyOneOption && onlyDisplayPrimaryLabel) && /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
        schemaHasHeading: rest.schemaHasHeading,
        numberOfInputs: rest.numberOfInputs
      }, (0, _utils2.stripHtml)(rest.label)), hint_text ? /*#__PURE__*/_react["default"].createElement(_formElements.HintText, {
        text: hint_text,
        id: "".concat(input.name, "_hint")
      }) : null, /*#__PURE__*/_react["default"].createElement("div", {
        role: "alert",
        id: buildUniqueId(config.name + '_error-message', null, '')
      }, showError && /*#__PURE__*/_react["default"].createElement("p", {
        className: "evi--error-text"
      }, /*#__PURE__*/_react["default"].createElement("strong", null, meta.error))), /*#__PURE__*/_react["default"].createElement(_commonComponents.GroupListHolder, {
        allowResponsiveLabel: false
      }, makeInputs(options, false, (0, _utils2.stripHtml)(rest.label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "exclusive-answers-divider"
      }), exclusiveOptions.length > 0 && makeInputs(exclusiveOptions, true, (0, _utils2.stripHtml)(rest.label)))));
    }
  }]);
}(_react.PureComponent);
CheckboxGroup.defaultProps = {
  ComponentWrapper: false,
  selectedValues: []
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(CheckboxGroup);